module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/108.cd5fa79e.png";